module.exports = __webpack_public_path__ + "f572638f/img/comments-icon.334fbbd6.svg";